$(document).ready(function () {

  $("#account").click(function () {
    $("#account").find(".menu").toggleClass("open");
  });
   
});
